import { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';

import { WithTooltip } from 'basic-components';

import { Else, If, Then } from 'react-if';

import classNames from 'classnames';

const SymbolCell = ({ children = "", isMedium = false, isLarge = false }) => {
  const taskPaneWidth = useSelector(state => state.globalState.taskPaneWidth),
        [isOverflowed, setIsOverflowed] = useState(false),
        timeoutRef = useRef(),
        ref = useRef()

  useEffect(() => {
    if(ref.current) {
      setIsOverflowed(ref.current.scrollWidth > ref.current.clientWidth)
    } else {
      window.clearTimeout(timeoutRef.current)
      timeoutRef.current = window.setTimeout(() => {
        if(ref.current) {
          setIsOverflowed(ref.current.scrollWidth > ref.current.clientWidth)
        }
      }, 5)
    }
  }, [taskPaneWidth])

  useEffect(() => () => {
    window.clearTimeout(timeoutRef.current)
  }, [])

  const content = (
    <div
        className={classNames(
          "ng-office-app__authed__content__results__body__scroll__row__cell__content",
          { "ng-office-app__authed__content__results__body__scroll__row__cell__content--is-overflowed": isOverflowed }
        )}
        ref={ref}
    >
      {children}
    </div>
  )

  return (
    <div
        className={classNames(
          "ng-office-app__authed__content__results__body__scroll__row__cell",
          { "ng-office-app__authed__content__results__body__scroll__row__cell--medium": isMedium },
          { "ng-office-app__authed__content__results__body__scroll__row__cell--large": isLarge }
        )}
        onMouseLeave={e => {
          e.target.scrollLeft = 0
        }}
    >
      <If condition={isOverflowed}>
        <Then>
          {() => (
            <WithTooltip
                data-place="top"
                text={children}
            >
              {content}
            </WithTooltip>
          )}
        </Then>
        <Else>
          {() => (
            content
          )}
        </Else>
      </If>
    </div>
  )
}

SymbolCell.propTypes = {
  children: PropTypes.string,
  isLarge: PropTypes.bool,
  isMedium: PropTypes.bool,
}

export default SymbolCell;
